export const EMPLOYER_BLOCKS_FETCH_BEGIN = 'syftacp/EMPLOYER_BLOCKS_FETCH_BEGIN' as const
export const EMPLOYER_BLOCKS_FETCH_FAILED = 'syftacp/EMPLOYER_BLOCKS_FETCH_FAILED' as const
export const EMPLOYER_BLOCKS_FETCH_SUCCEEDED = 'syftacp/EMPLOYER_BLOCKS_FETCH_SUCCEEDED' as const
